/**
 * Dev-only bootstrap: global process shim + CRA error-overlay iframe fix.
 * ESLint warnings in the console do not crash the app; a runtime error opens
 * the overlay, which evals bundle snippets in an iframe without `process`.
 */
/* eslint-disable */

function ensureProcess(target) {
  if (!target || target.process) {
    return;
  }
  target.process = {
    env: {
      NODE_ENV: 'development',
      PUBLIC_URL: '',
    },
    browser: true,
  };
}

ensureProcess(typeof globalThis !== 'undefined' ? globalThis : undefined);
ensureProcess(typeof window !== 'undefined' ? window : undefined);

if (typeof window !== 'undefined') {
  const syncOverlayFrames = () => {
    ensureProcess(window);
    document.querySelectorAll('iframe').forEach((frame) => {
      try {
        ensureProcess(frame.contentWindow);
      } catch (_) {
        // cross-origin iframe
      }
    });
  };

  syncOverlayFrames();
  new MutationObserver(syncOverlayFrames).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('error', (event) => {
    // Log the real error before/alongside the overlay (look for this line in DevTools)
    console.error('[Sensia] Uncaught error:', event.error || event.message, event);
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Sensia] Unhandled promise rejection:', event.reason);
  });
}
